import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { RedirectTotalSaved } from 'components/RedirectTotalSaved';
import { getCurrencyCode } from 'modules/meta/selectors';
import RedirectLoader from '../../components/RedirectLoader';
import RedirectMessage from '../../components/RedirectMessage';
interface ProviderRedirectQueryParamsType {
  anchorPrice: string;
  currency: string;
  lang: string;
  providerCode: string;
  providerName?: string;
  redirectURI: string;
  totalPrice: string;
  yourChoice: string;
  isGems: string;
}
interface Props {
  brandProviderCode: string;
  params: ProviderRedirectQueryParamsType;
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w12ym7nn",
  propsAsIs: false
});
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "cx9furf",
  propsAsIs: false
});
const ProviderRedirect = ({
  brandProviderCode,
  params
}: Props) => {
  const providerCode = params.providerCode.toLowerCase();
  const currency = useSelector(getCurrencyCode);
  const anchorPrice = Number.parseInt(params.anchorPrice, 10);
  const totalPrice = Number.parseInt(params.totalPrice, 10);
  const DefaultRedirect = () => <Container>
      <RedirectTotalSaved currency={currency} brandCode={brandProviderCode} totalPrice={totalPrice} anchorPrice={anchorPrice} />
      <RedirectLoader />
      <RedirectMessage providerCode={providerCode} />
    </Container>;
  return <Wrapper>
      <DefaultRedirect />
    </Wrapper>;
};
export default ProviderRedirect;

require("./ProviderRedirect.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProviderRedirect.tsx");